import { InsuranceType } from '../insurance-type.enum';

export enum ClaimType {
  TRAVEL = 'TRAVEL',
  BUILDING = 'BUILDING',
  RC_HOUSEHOLD = 'RC_HOUSEHOLD',
  LEGAL_PROTECTION = 'LEGAL_PROTECTION',
  MOTOR_VEHICLE = 'MOTOR_VEHICLE',
  ANIMAL = 'ANIMAL',
  VALUABLE_OBJECTS = 'QUOTATION_REQUEST',
  CONSTRUCTION = 'CONSTRUCTION',
  BUSINESS_ACCIDENT = 'BUSINESS_ACCIDENT',
  BUSINESS_HEALTH = 'BUSINESS_HEALTH',
  BUSINESS_RC_COMPANY = 'BUSINESS_RC_COMPANY',
  BUSINESS_COMPANY_THINGS = 'BUSINESS_COMPANY_THINGS',
  BUSINESS_MOTOR_VEHICLE = 'BUSINESS_MOTOR_VEHICLE',
  BUSINESS_RETIREMENT = 'BUSINESS_RETIREMENT',
  BUSINESS_LEGAL_PROTECTION = 'BUSINESS_LEGAL_PROTECTION',
  BUSINESS_BUILDING = 'BUSINESS_BUILDING',
  BUSINESS_CONSTRUCTION = 'BUSINESS_CONSTRUCTION',
  BUSINESS_TRANSPORT = 'BUSINESS_TRANSPORT',
  BUSINESS_CYBERSECURITY = 'BUSINESS_CYBERSECURITY',
  BUSINESS_TECHNICAL_INSTALLATION = 'BUSINESS_TECHNICAL_INSTALLATION',
  BUSINESS_FLEET = 'BUSINESS_FLEET',
  ACCIDENT = 'ACCIDENT',
  HEALTH_ALLOWANCE = 'HEALTH_ALLOWANCE',
}

export const getClaimTypeLabel = (type: ClaimType): string => {
  switch (type) {
    case ClaimType.TRAVEL:
      return $localize`Voyage`;
    case ClaimType.BUILDING:
      return $localize`Bâtiment`;
    case ClaimType.RC_HOUSEHOLD:
      return $localize`RC ménage`;
    case ClaimType.LEGAL_PROTECTION:
      return $localize`Protection juridique`;
    case ClaimType.MOTOR_VEHICLE:
      return $localize`Véhicule à moteur`;
    case ClaimType.ANIMAL:
      return $localize`Animal`;
    case ClaimType.VALUABLE_OBJECTS:
      return $localize`Objet de valeur`;
    case ClaimType.CONSTRUCTION:
      return $localize`Construction`;
    case ClaimType.BUSINESS_ACCIDENT:
      return $localize`LAA`;
    case ClaimType.BUSINESS_HEALTH:
      return $localize`IJM`;
    case ClaimType.BUSINESS_RC_COMPANY:
      return $localize`RC entreprise`;
    case ClaimType.BUSINESS_COMPANY_THINGS:
      return $localize`Choses de l'entreprise`;
    case ClaimType.BUSINESS_MOTOR_VEHICLE:
      return $localize`Véhicule à moteur entreprise`;
    case ClaimType.BUSINESS_RETIREMENT:
      return $localize`LPP`;
    case ClaimType.BUSINESS_LEGAL_PROTECTION:
      return $localize`Protection juridique entreprise`;
    case ClaimType.BUSINESS_BUILDING:
      return $localize`Bâtiment entreprise`;
    case ClaimType.BUSINESS_CONSTRUCTION:
      return $localize`Construction entreprise`;
    case ClaimType.BUSINESS_TRANSPORT:
      return $localize`Transport`;
    case ClaimType.BUSINESS_CYBERSECURITY:
      return $localize`Cybersécurité`;
    case ClaimType.BUSINESS_TECHNICAL_INSTALLATION:
      return $localize`Installation technique`;
    case ClaimType.BUSINESS_FLEET:
      return $localize`Flotte véhicule`;
    case ClaimType.ACCIDENT:
      return $localize`Accident privé`;
    case ClaimType.HEALTH_ALLOWANCE:
      return $localize`IJM privé`;
    default:
      return '';
  }
};

export const claimTypeToInsuranceType = (type: ClaimType): InsuranceType => {
  switch (type) {
    case ClaimType.TRAVEL:
      return InsuranceType.TRAVEL;
    case ClaimType.BUILDING:
      return InsuranceType.BUILDING;
    case ClaimType.RC_HOUSEHOLD:
      return InsuranceType.RC_HOUSEHOLD;
    case ClaimType.LEGAL_PROTECTION:
      return InsuranceType.LEGAL_PROTECTION;
    case ClaimType.MOTOR_VEHICLE:
      return InsuranceType.MOTOR_VEHICLE;
    case ClaimType.ANIMAL:
      return InsuranceType.ANIMAL;
    case ClaimType.VALUABLE_OBJECTS:
      return InsuranceType.VALUABLE_OBJECTS;
    case ClaimType.CONSTRUCTION:
      return InsuranceType.CONSTRUCTION;
    case ClaimType.BUSINESS_ACCIDENT:
      return InsuranceType.BUSINESS_ACCIDENT;
    case ClaimType.BUSINESS_HEALTH:
      return InsuranceType.BUSINESS_HEALTH;
    case ClaimType.BUSINESS_RC_COMPANY:
      return InsuranceType.BUSINESS_RC_COMPANY;
    case ClaimType.BUSINESS_COMPANY_THINGS:
      return InsuranceType.BUSINESS_COMPANY_THINGS;
    case ClaimType.BUSINESS_MOTOR_VEHICLE:
      return InsuranceType.BUSINESS_MOTOR_VEHICLE;
    case ClaimType.BUSINESS_RETIREMENT:
      return InsuranceType.BUSINESS_RETIREMENT;
    case ClaimType.BUSINESS_LEGAL_PROTECTION:
      return InsuranceType.BUSINESS_LEGAL_PROTECTION;
    case ClaimType.BUSINESS_BUILDING:
      return InsuranceType.BUSINESS_BUILDING;
    case ClaimType.BUSINESS_CONSTRUCTION:
      return InsuranceType.BUSINESS_CONSTRUCTION;
    case ClaimType.BUSINESS_CYBERSECURITY:
      return InsuranceType.BUSINESS_CYBERSECURITY;
    case ClaimType.BUSINESS_TECHNICAL_INSTALLATION:
      return InsuranceType.BUSINESS_TECHNICAL_INSTALLATION;
    case ClaimType.BUSINESS_TRANSPORT:
      return InsuranceType.BUSINESS_TRANSPORT;
    case ClaimType.BUSINESS_FLEET:
      return InsuranceType.BUSINESS_FLEET;
    case ClaimType.ACCIDENT:
      return InsuranceType.ACCIDENT;
    case ClaimType.HEALTH_ALLOWANCE:
      return InsuranceType.HEALTH_ALLOWANCE;
  }
};

export const insuranceTypeToClaimType = (
  type: InsuranceType
): ClaimType | null => {
  switch (type) {
    case InsuranceType.TRAVEL:
      return ClaimType.TRAVEL;
    case InsuranceType.BUILDING:
      return ClaimType.BUILDING;
    case InsuranceType.RC_HOUSEHOLD:
      return ClaimType.RC_HOUSEHOLD;
    case InsuranceType.LEGAL_PROTECTION:
      return ClaimType.LEGAL_PROTECTION;
    case InsuranceType.MOTOR_VEHICLE:
      return ClaimType.MOTOR_VEHICLE;
    case InsuranceType.ANIMAL:
      return ClaimType.ANIMAL;
    case InsuranceType.VALUABLE_OBJECTS:
      return ClaimType.VALUABLE_OBJECTS;
    case InsuranceType.CONSTRUCTION:
      return ClaimType.CONSTRUCTION;
    case InsuranceType.BUSINESS_ACCIDENT:
      return ClaimType.BUSINESS_ACCIDENT;
    case InsuranceType.BUSINESS_HEALTH:
      return ClaimType.BUSINESS_HEALTH;
    case InsuranceType.BUSINESS_RC_COMPANY:
      return ClaimType.BUSINESS_RC_COMPANY;
    case InsuranceType.BUSINESS_COMPANY_THINGS:
      return ClaimType.BUSINESS_COMPANY_THINGS;
    case InsuranceType.BUSINESS_MOTOR_VEHICLE:
      return ClaimType.BUSINESS_MOTOR_VEHICLE;
    case InsuranceType.BUSINESS_RETIREMENT:
      return ClaimType.BUSINESS_RETIREMENT;
    case InsuranceType.BUSINESS_LEGAL_PROTECTION:
      return ClaimType.BUSINESS_LEGAL_PROTECTION;
    case InsuranceType.BUSINESS_BUILDING:
      return ClaimType.BUSINESS_BUILDING;
    case InsuranceType.BUSINESS_CONSTRUCTION:
      return ClaimType.BUSINESS_CONSTRUCTION;
    case InsuranceType.BUSINESS_CYBERSECURITY:
      return ClaimType.BUSINESS_CYBERSECURITY;
    case InsuranceType.BUSINESS_TECHNICAL_INSTALLATION:
      return ClaimType.BUSINESS_TECHNICAL_INSTALLATION;
    case InsuranceType.BUSINESS_TRANSPORT:
      return ClaimType.BUSINESS_TRANSPORT;
    case InsuranceType.BUSINESS_FLEET:
      return ClaimType.BUSINESS_FLEET;
    case InsuranceType.ACCIDENT:
      return ClaimType.ACCIDENT;
    case InsuranceType.HEALTH_ALLOWANCE:
      return ClaimType.HEALTH_ALLOWANCE;
    default:
      return null;
  }
};

export const isPersonalClaim = (type: ClaimType) =>
  PERSONAL_CLAIMS.includes(type);

export const PERSONAL_CLAIMS = [
  ClaimType.TRAVEL,
  ClaimType.BUILDING,
  ClaimType.RC_HOUSEHOLD,
  ClaimType.LEGAL_PROTECTION,
  ClaimType.MOTOR_VEHICLE,
  ClaimType.ANIMAL,
  ClaimType.VALUABLE_OBJECTS,
  ClaimType.CONSTRUCTION,
  ClaimType.ACCIDENT,
  ClaimType.HEALTH_ALLOWANCE,
];

export const BUSINESS_CLAIMS = [
  ClaimType.BUSINESS_ACCIDENT,
  ClaimType.BUSINESS_HEALTH,
  ClaimType.BUSINESS_RC_COMPANY,
  ClaimType.BUSINESS_COMPANY_THINGS,
  ClaimType.BUSINESS_BUILDING,
  ClaimType.BUSINESS_CONSTRUCTION,
  ClaimType.BUSINESS_CYBERSECURITY,
  ClaimType.BUSINESS_LEGAL_PROTECTION,
  ClaimType.BUSINESS_TECHNICAL_INSTALLATION,
  ClaimType.BUSINESS_RETIREMENT,
  ClaimType.BUSINESS_TRANSPORT,
  ClaimType.BUSINESS_MOTOR_VEHICLE,
  ClaimType.BUSINESS_FLEET,
];
